import { render, staticRenderFns } from "./SfProductCard.vue?vue&type=template&id=a5b28012&scoped=true&"
import script from "./SfProductCard.vue?vue&type=script&lang=ts&"
export * from "./SfProductCard.vue?vue&type=script&lang=ts&"
import style0 from "./SfProductCard.vue?vue&type=style&index=0&id=a5b28012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b28012",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductLabels: require('/usr/src/app/components/storyblok/ProductLabels.vue').default})
